import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const buttonCss = "b12axqrm";
const Button = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(buttonCss, props.className)} />);
export const AccordionItem = ({
  header,
  children,
  isActive,
  onHeaderClick
}) => <div>
    <Button onClick={onHeaderClick}>
      {header}
      {isActive ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />}
    </Button>
    {isActive && <div>{children}</div>}
  </div>;

require("./accordion_item.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./accordion_item.js");